export default __webpack_public_path__ + "static/media/primeicons.78172950.woff2";